// Module
var code = `<div ng-class="\$ctrl.heightClass || 'h-75'"></div> `;
// Exports
export default code;